site.hero = {
	init:function() {
		if (!$('body').hasClass('frontpage')) return false;
		if ($('#hero li').length > 1) {
			site.owl.init('#hero > ul', {
				loop: true,
				dots: true,
				nav: false,
				items: 1,
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				onDrag: function () {
					$('#hero .owl-controls').hide();
				},
				onDragged: function () {
					$('#hero .owl-controls').show();
				},
				onInitialized: function() {
					$('#hero .owl-dot').keydown(function (e) {
						if (e.which == 13) {
							$(e.target).click();
						}
					});
				},
				onTranslated: function() {
					$('#hero .owl-item a').attr('tabindex', '-1');
					$('#hero .owl-item.active a').attr('tabindex', '4');
				}
			});
		}

		if ($('#carousel li').length > 1) {
			site.owl.init('#carousel > ul', {
				loop: true,
				dots: false,
				nav: true,
				navText: ["", ""],
				margin:15,
				responsive:{
					// breakpoint from 0 up
					0:{
						items:1
					},
					// breakpoint from 480 up
					480:{
						items:3
					},
					// breakpoint from 768 up
					768:{
						items:4
					},
					// breakpoint from 992 up
					992:{
						items:5
					},
					// breakpoint from 1200 up
					1200:{
						items:7
					}
				}
			});
		}
	}
};


site.store = {
	init: function () {
		$('body').on('click', '#storeCart .showMore', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');

			$('body.cart-open').on('click', function (e) {
				if (!$(e.target).parents('#storeCart').length) {
					$('body').removeClass('cart-open');
				}
			});
		});

		if ($('body').hasClass('productView')) {
			$('ul.albumImages .productImage.first').addClass('active');

			$('ul.albumImages .productImage').on('click', function (e) {
				if (!this.classList.contains('active')) {
					$('ul.albumImages .productImage.active').removeClass('active');
					this.classList.add('active');
				}
			});

			// if ($fieldset.hasClass('disabled')) {
			// 	$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
			// }
			// else {
			// 	$fieldset.find('input:not(.checkbox)').attr('disabled', null);
			// }
		}

		//Store
		if ($('body').hasClass('store')) {
			site.owl.init('.product .albumImages', {
				loop: false,
				dots: false,
				nav: true,
				items: 4,
				navText: ["", ""],
				margin: 20,
				responsive: {
					// breakpoint from 0 up
					0:{
						items:2
					},
					// breakpoint from 480 up
					480:{
						items:2
					},
					// breakpoint from 1200 up
					1200:{
						items:3
					}
				}
			});

			$('.like, .pin', '.product .social').click(function(){
				$(this).toggleClass('open');
			});
		}

		//Checkout
		if ($('body').hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	},
};

site.inits.push('site.hero.init()');
site.inits.push('site.store.init()');

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
	$('body').addClass('cart-open');
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	$('ul.albumImages a').click(function(e) {
		e.preventDefault();
		$href = $(this).attr('href');
		$src = $(this).data('image');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$('a', $image).attr("href", $href);
			$('img', $image).attr("src", $src).load(function() {
				$('.loading',$image).remove();
			});
		}
	});
};

store.local.fixFancyPreViewImageClick = function() {

	$('ul.albumImages .productImage.first a').click(function(e) {
		e.preventDefault();
		$('.side .images .image a').trigger('click');
	});

};

store.local.initAttributes = function(data, currentVariantKey) {
	var $store = store.$();
	var wrap = $store.find('.variantSelection');
	var html = '';
	store.attributeSort = data.attributeSort;
	store.attributes = data.attributes;
	store.variants = data.variants;
	store.initialProductClasses = $store.find('.product').attr('class').split(' ');

	for (var i= 0,c=data.attributeSort.length; i<c; i++) {
		var aId = data.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		var a = data.attributes[aId];
		var aData = a.data;
		if (aData.isOption) {
			var selectId = 'attribute_' + aData.codename;
			a.selectId = selectId;
			var label = '<label for="' + selectId + '">' + aData.name + ':</label>';
			var aType = aData.type;
			var select = '';
			if (aType == 'color') {
				select = store.attributeColorSelect(selectId, a.values);
			}
			else {
				select = store.attributeNormalSelect(selectId, a.values);
			}

			html += '<div class="attribute">' + label + select + '</div>';
		}
	}
	wrap.html(html);
	$store.find('.attribute select').change(function(){
		store.local.updateVariantData();
	});
	$store.find('.attribute span.color').click(store.local.updateVariantColor);
	store.local.selectVariant(currentVariantKey);
};

store.local.updateVariantColor = function() {
	var t = $(this);
	var rel = t.attr('rel');
	var p = t.parent();
	$('input', p).val(rel);
	store.local.updateVariantData();
};

store.local.selectVariant = function (currentVariantKey)
{
	var values = currentVariantKey.split('_');
	for (var i= 0,cas=store.attributeSort.length; i<cas; i++) {
		var aId = store.attributeSort[i];
		for (var v= 0, c=values.length; v < c; v++) {
			var vId = values[v];
			var vvId = 'v'+vId;
			//noinspection JSUnfilteredForInLoop
			if (store.attributes[aId].values[vvId]) {
				//noinspection JSUnfilteredForInLoop
				var e = $('#' + store.attributes[aId].selectId);
				e.val(vId);
			}
		}
	}
	store.local.updateVariantData();
	store.local.onSelectVariant(currentVariantKey);
};

store.local.updateVariantData = function() {
	var values = [];
	var aId, a, sel, i, c;
	for (i = 0,c = store.attributeSort.length; i < c; i++) {
		aId = store.attributeSort[i];
		//noinspection JSUnfilteredForInLoop
		a = store.attributes[aId];
		if (a.selectId) {
			//noinspection JSJQueryEfficiency
			sel = $('#' + a.selectId);
			var v1 = sel.val();
			if (v1) {
				v1 = parseInt(v1);
				values.push(v1);
			}
		}
	}
	var key = values.join('_');
	if (store.variants[key]) {
		var variant = store.variants[key];
		var $store = store.$();
		$store.find('.priceDetail .priceValue').html(variant.price);
		$store.find('.availability').replaceWith(variant.stock);
		$store.find('div.qtyWrap').replaceWith(variant.qty);
		$store.find('div.reference').replaceWith(variant.reference);
		if (variant.compareLink) {
			$store.find('div.compareLink').replaceWith(variant.compareLink);
		}

		$store.find('.product .side .image').replaceWith(variant.img);
		$store.find('.product .side .image a.fancybox').fancybox();
		store.responsiveImg($store.find('.product .side .image'));
		$store.find('#variant').val(variant.id).trigger('change');
		$store.find('#price').val(variant.priceId).trigger('change');
		store.updateAttributes(variant);
		store.updateBuyButton();
		store.updateVariantClasses(variant);

		for (i= 0,c=store.attributeSort.length; i<c; i++) {
			aId = store.attributeSort[i];
			//noinspection JSUnfilteredForInLoop
			a = store.attributes[aId];
			if (a.data.type == 'color') {
				//noinspection JSJQueryEfficiency
				sel = $('#' + a.selectId);
				var v2 = sel.val();
				var wrap = $('#' + a.selectId + '_wrap');
				wrap.find('.color').removeClass('selected');
				wrap.find('.c_' + v2).addClass('selected');
			}
		}
		store.local.onUpdateVariantData(variant);
	}
	else {
		store.message.error(store.t.__('variantNotAvailable'), 'Athuga', null, 'updateVariantData');
	}
};
